import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchPortfolioOwnedAssets } from '../../services/PortfolioApi/portfolioApi';
import { toastNotify } from '../../utils/toastNotify';

const initialState = {
  loading: false,
  data: {},
};

export const fetchOwnedAssetsAction = createAsyncThunk('FETCH_PORTFOLIO_OWNED_aSSET_DETAILS', fetchPortfolioOwnedAssets);
export const ownedAssetDetailSlice = createSlice({
  name: 'ownedAssetDetails',
  initialState,
  reducers: {
    updateOwnedAssetDetails: (state, action) => {
      state.data = { ...action.payload };
    },
  },
  extraReducers: {
    [fetchOwnedAssetsAction.pending]: (state, action) => {
      return {
        ...state,
        loading: true,
      };
    },
    [fetchOwnedAssetsAction.fulfilled]: (state, action) => {
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    },
    [fetchOwnedAssetsAction.rejected]: (state, action) => {
      toastNotify('error', action.payload);
      return {
        ...state,
        loading: false,
        data: {},
      };
    },
  },
});

export const { updateOwnedAssetDetails } = ownedAssetDetailSlice.actions;
const { reducer } = ownedAssetDetailSlice;

export default reducer;
